import { Discount } from '../models/serializable/discounts/discount.js';
import { Price } from '../models/serializable/price.js';
import { TrackingPromoCode } from '../models/serializable/discounts/tracking-promo-code.js';
import { DiscountModifier, DiscountProvider } from './discount-provider.js';
import { DiscountFactory } from '../factories/discount-factory.js';

export class TrackingPromoCodeDiscountProvider extends DiscountProvider {
  constructor(private readonly trackingCode: TrackingPromoCode) {
    super();
  }

  findDiscountForMultipleTickets(ticketId: string, quantity: number): DiscountModifier | null {
    return null;
  }

  findDiscountForSingleTicket(ticketId: string): Discount | null {
    return null;
  }

  findDiscountForOrder(orderPrice: Price): Discount | null {
    return DiscountFactory.fromTrackingCode(this.trackingCode);
  }

  reset(): void {
    // Nothing to do here.
  }
}
